import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import BusinessCard from "@/components/BusinessCard";
import { Spinner, EmptyState } from "@/components/States";
import { ChevronLeft, Search, X } from "lucide-react";

export default function SearchPage() {
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  useEffect(() => {
    if (!q.trim()) {
      setItems([]);
      setTouched(false);
      return;
    }
    setTouched(true);
    setLoading(true);
    const t = setTimeout(() => {
      api
        .get("/businesses", { params: { q: q.trim() } })
        .then((r) => setItems(r.data))
        .finally(() => setLoading(false));
    }, 300);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="relative mx-auto min-h-screen w-full max-w-md bg-[#FDFBF7]">
      <header className="sticky top-0 z-40 glass border-b border-black/5 px-5 pb-3 pt-5">
        <div className="flex items-center gap-2">
          <button onClick={() => navigate(-1)} data-testid="search-back" className="rounded-full bg-[#F3F0E6] p-2">
            <ChevronLeft size={20} />
          </button>
          <div className="flex flex-1 items-center gap-2 rounded-2xl border border-black/5 bg-white px-3 py-2.5">
            <Search size={18} className="text-[#5C5C5C]" />
            <input
              ref={inputRef}
              value={q}
              onChange={(e) => setQ(e.target.value)}
              data-testid="search-input"
              placeholder="Buscar por nombre o categoría..."
              className="w-full bg-transparent text-sm outline-none placeholder:text-[#9c9c9c]"
            />
            {q && (
              <button onClick={() => setQ("")} data-testid="search-clear">
                <X size={16} className="text-[#5C5C5C]" />
              </button>
            )}
          </div>
        </div>
      </header>

      {loading ? (
        <Spinner />
      ) : !touched ? (
        <EmptyState title="Busca negocios" subtitle="Escribe el nombre, categoría o colonia." />
      ) : items.length === 0 ? (
        <EmptyState title={`Sin resultados para "${q}"`} subtitle="Intenta con otra palabra." />
      ) : (
        <section className="flex flex-col gap-4 px-5 pt-4 pb-8">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1A1A1A]">
            {items.length} resultado(s)
          </p>
          {items.map((b, i) => (
            <BusinessCard key={b.id} business={b} index={i} />
          ))}
        </section>
      )}
    </div>
  );
}
